import config from "../../MassivelyDistributed/Configs/config";

const createPackMixerState = (numSamples) => {
    return Array(numSamples).fill(config.ui_settings.mixer.default_volume);
}

export { createPackMixerState };